<template>
  <div class="header">
    <a-dropdown>
      <a-icon class="user-trigger" type="user" />
      <a-menu slot="overlay" :selectedKeys="['loginout']">
        <a-menu-item
          key="usersettingshopinfo"
          @click="setting('usersettingshopinfo')"
          >店铺设置</a-menu-item
        >
        <a-menu-item
          key="usersettinguserinfo"
          @click="setting('usersettingsiteinfo')"
          >网站设置</a-menu-item
        >
        <a-menu-item key="loginout" @click="loginout">退出登录</a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  methods: {
    loginout: function() {
      Vue.ls.remove("SS");
      Vue.ls.remove("INFO");
      this.$router.push({ name: "login" });
    },
    setting: function(item) {
      this.$router.push({ name: item });
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  float: right;
  margin-right: 10px;
  .user-trigger {
    padding: 0 20px;
    line-height: 64px;
    font-size: 20px;
    &:hover {
      background: rgba(240, 240, 240, 0.4);
    }
  }
}
</style>
